import { jsx as o } from "react/jsx-runtime";
import r from "./LoggedIn/LoggedIn.js";
import n from "./LoggedOut/LoggedOut.js";
import { LoginProvider as e, useLoginContext as i } from "./context.js";
const g = () => i().isLoggedIn ? /* @__PURE__ */ o(r, {}) : /* @__PURE__ */ o(n, {}), u = (t) => /* @__PURE__ */ o(e, { ...t, children: /* @__PURE__ */ o(g, {}) });
export {
  u as Login,
  u as default
};
